import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import Pill from '../components/c-pill';
import { useHistory } from 'react-router-dom';
import { useLocalStorage } from 'beautiful-react-hooks';

export default function Pick() {
	const h = useHistory();
	const [session, setSession] = useLocalStorage('session');

	useEffect(() => {
		try {
			if (session) {
				(async () => {
					const { token, puid, srv } = session;
					const action = 'pick';
					const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
					await axios.post(`${base}/${puid}/act`, { action }, { headers: { Authorization: `Bearer ${token}` } });
				})();
			}
		} catch (error) {
			console.log('error', error);
		}
	}, [session]);

	const pick = async (id) => {
		console.log('pick', id);
		try {
			if (session) {
				const _session = { ...session };
				const { token, puid, srv } = session;

				const action = 'replay';
				const value = id;

				const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
				await axios.post(`${base}/${puid}/act`, { action, value }, { headers: { Authorization: `Bearer ${token}` } });

				_session.option = id;

				setSession(_session);
				setImmediate(() => {
					h.push('/E');
				});
			}
		} catch (error) {
			console.log('error', error);
		}
	};

	return (
		<IonPage>
			<IonContent fullscreen scrollY={true}>
				<div className='w-full min-h-full h-auto justify-items-center items-center flex flex-col bg-c-purple'>
					<img src='/assets/media/tela-4-mobile-1.png' className='mt-12' />
					<motion.img src='/assets/media/bt-choose-1.png' className='mt-20' onTap={() => pick(1)} />
					<motion.img src='/assets/media/bt-choose-2.png' className='mt-8' onTap={() => pick(2)} />
					<motion.img src='/assets/media/bt-choose-3.png' className='mt-8' onTap={() => pick(3)} />
				</div>
			</IonContent>
		</IonPage>
	);
}
